import React from "react";

const Preorder = () => {
  return (
    <div className="min-h-[600px] p-4 bg-transparent flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-4 md:gap-6">
        <h1 className="text-white font-rubik font-bold text-xl md:text-4xl">
          Assassin's Creed Pre-order
        </h1>
        <p className="text-[#d4d4d4] text-[18px] font-rubik max-w-[650px] text-center">
        Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do Eiusmod
        Tempor Incididunt Ut Labore Et Dolore Magna Aliqua. Ut Enim Ad
        </p>
        <button className="text-base min-w-[100px] md:min-w-[170px] font-rubik font-medium bg-primary p-1 md:p-4 rounded-full text-white">
          Shop Now
        </button>
      </div>
    </div>
  );
};

export default Preorder;
